export default {
  SET_TIMEKIT_PROJECT_LIST: (state, { projectList }) => {
    state.projectList = projectList;
  },

  SET_ASSIGNMENT_CONTENT: (state, { content }) => {
    state.assignment_content = content;
  },
  SET_ASSIGNMENT_CONTENT_TYPE: (state, { content_type }) => {
    state.assignment_content_type = content_type;
  },

  SET_CREATING_ASSIGNMENT : (state, {data}) =>{
    state.creating_assignment = data
  },
  SET_ASSIGNMENT_CREATED : (state, {data}) =>{
    state.assignment_created = data
  },
  SET_MAGIC_OTP_LOADING: (state, { data }) => {
    state.magicOtpLoading = data;
  },
  SET_MAGIC_OTP_SAVING: (state, { data }) => {
    state.magicOtpSaving = data;
  },
  SET_MAGIC_OTP: (state, { data }) => {
    state.magicOtp = data;
  },
  SET_SCHOOL_MAGIC_OTP_LIST: (state, { data }) => {
    state.schoolMagicOtpList = data;
  },
  SET_SCHOOL_MAGIC_OTP_PAGE: (state, { data }) => {
    state.schoolMagicOtpPage = data;
  },
  SET_SCHOOL_MAGIC_OTP_GRADES: (state, { data }) => {
    state.schoolMagicOtpGrades = data;
  },
  SET_SCHOOL_MAGIC_OTP_LOADING: (state, { data }) => {
    state.schoolMagicOtpLoading = data;
  },
  SET_SCHOOL_MAGIC_OTP_SAVING: (state, { data }) => {
    state.schoolMagicOtpSaving = data;
  },
  SET_SCHOOL_MAGIC_OTP_SAVED_AT: (state, { data }) => {
    state.schoolMagicOtpSavedAt = data;
  }
};
